import React from "react";
import { Link, useLocation } from 'react-router-dom';
import { logEvent } from "../utils/google_analytics";
export default function SideBar() {
    const location = useLocation();
    const [isLoginActive, setIsLoginActive] = React.useState(false);
    const [isPolicyOpen, setIsPolicyOpen] = React.useState(false);
    const scrollToTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    };

    React.useEffect(() => {
        setIsLoginActive(false);
    }, [location.pathname]);

    React.useEffect(() => {
        scrollToTop();
    }, [location.pathname]);

    React.useEffect(() => {
        const modalElement = document.getElementById("modal-login");
        if (!modalElement) return;

        const handleModalHidden = () => {
            setIsLoginActive(false);
        };

        modalElement.addEventListener("hidden", handleModalHidden);

        return () => {
            modalElement.removeEventListener("hidden", handleModalHidden);
        };
    }, []);

    const openLoginModal = (e) => {
        e.preventDefault();
        setIsLoginActive(true);
        if (window.UIkit && typeof window.UIkit.modal === "function") {
            window.UIkit.modal("#modal-login", { container: false }).show();
        }
    };

    const isActivePath = (path) => location.pathname === path;
    const isMagazinePath = location.pathname === "/magazine" || location.pathname.startsWith("/magazine/read/");
    const isPolicyPath = (path) => location.pathname === path;
    const isAnyPolicyActive =
        isPolicyPath("/terms-and-conditions") ||
        isPolicyPath("/privacy-policy") ||
        isPolicyPath("/cookie-policy") ||
        isPolicyPath("/community-guidelines");

    React.useEffect(() => {
        if (isAnyPolicyActive) {
            setIsPolicyOpen(true);
        }
    }, [isAnyPolicyActive]);

    const togglePolicyMenu = (e) => {
        e.preventDefault();
        setIsPolicyOpen((prev) => !prev);
    };

    const startRoutePreloader = (targetPath) => (e) => {
        if (targetPath && location.pathname === targetPath) {
            e.preventDefault();
            scrollToTop();
            window.dispatchEvent(new CustomEvent("app:navigation-end"));
            return;
        }

        scrollToTop();
        window.dispatchEvent(new CustomEvent("app:navigation-start"));
    };

    return (
        <>
            <aside className="sidebar" id="sidebar">
                <div className="sidebar-hider">
                    <i className="icon-arrow-left"></i>
                    <i className="icon-arrow-right"></i>
                </div>

                <div className="sidebar-box">
                    <ul className="uk-nav">
                        <li className={isActivePath("/") ? "uk-active" : ""}>
                            <Link to="/" onClick={startRoutePreloader("/")}>
                                <i className="fa-solid fa-house fa-lg" title="Home"></i>
                                <span>Home</span>
                            </Link>
                        </li>

                        <li className="uk-nav-header">
                            <i className="uk-nav-devider"></i>
                            <span>Main Menu</span>
                        </li>
                        <li className={isActivePath("/games") ? "uk-active" : ""}>
                            <Link to="/games" onClick={startRoutePreloader("/games")}>
                                <i className="fa-solid fa-gamepad fa-lg" title="Games"></i>
                                <span>Free Games</span>
                            </Link>
                        </li>

                        <li className={isActivePath("/tournaments") ? "uk-active" : ""}>
                            <Link to="/tournaments" onClick={startRoutePreloader("/tournaments")}>
                                <i className="fa-solid fa-medal fa-lg" title="Tournaments"></i>
                                <span>Tournaments</span>
                            </Link>
                        </li>

                        <li className={isActivePath("/leaderboard") ? "uk-active" : ""}>
                            <Link to="/leaderboard" onClick={startRoutePreloader("/leaderboard")}>
                                <i className="fa-solid fa-trophy fa-lg" title="Leaderboards"></i>
                                <span>Leaderboard</span>
                            </Link>
                        </li>

                        {/* <li className={isActivePath("/mvp") ? "uk-active" : ""}>
                            <Link to="/mvp" onClick={startRoutePreloader("/mvp")}>
                                <i className="fa-solid fa-ranking-star fa-lg" title="MVP Ranking"></i>
                                <span>MVP Ranking</span>
                            </Link>
                        </li> */}

                        <li className={isActivePath("/store") ? "uk-active" : ""}>
                            <Link to="/store" onClick={startRoutePreloader("/store")}>
                                <i className="fa-solid fa-basket-shopping fa-lg" title="Store"></i>
                                <span>Store</span>
                            </Link>
                        </li>

                        

                        <li className={isActivePath("/blog") ? "uk-active" : ""}>
                            <Link to="/blog" onClick={startRoutePreloader("/blog")}>
                                <i className="fa-solid fa-blog fa-lg" title="Blog"></i>
                                <span>Blog</span>
                            </Link>
                        </li>

                        {/* <li className={isMagazinePath ? "uk-active" : ""}>
                            <Link to="/magazine" onClick={startRoutePreloader}>
                                <i className="fa-solid fa-book-open fa-lg" title="Magazine"></i>
                                <span>Magazine</span>
                                </Link>
                        </li> */}
                        {/* <li className={isActivePath("/gamejam") ? "uk-active" : ""}>
                            <Link to="/gamejam" onClick={startRoutePreloader("/gamejam")}>
                                <i className="fa-solid fa-gamepad fa-lg" title="Blog"></i>
                                <span>GameJam</span>
                            </Link>
                        </li> */}
                        <li className={isActivePath("/e-magazines") ? "uk-active" : ""}>
                            <Link to="/e-magazines" onClick={startRoutePreloader("/e-magazines")}>
                                <i className="fa-solid fa-book-open fa-lg" title="Magazine"></i>
                                <span>E-Magazines</span>
                            </Link>
                        </li>
                        <li className={isActivePath("/media-kit") ? "uk-active" : ""}>
                            <Link to="/media-kit" onClick={startRoutePreloader("/media-kit")}>
                                <i className="fa-solid fa-image fa-lg" title="Mediakit"></i>
                                <span>Media Kit</span>
                            </Link>
                        </li>

                        <li className="uk-nav-header">
                            <i className="uk-nav-devider" title="Accounts"></i>
                            <span>Account</span>
                        </li>

                        <li className={isActivePath("/profile") ? "uk-active" : ""}>
                            <Link to="/profile" onClick={startRoutePreloader("/profile")}>
                                <i className="fa-solid fa-user fa-lg" title="Profile"></i>
                                <span>Profile</span>
                            </Link>
                        </li>

                        {/* <li className={isActivePath("/wallet") ? "uk-active" : ""}>
                            <Link to="/wallet">
                                <i className="fa-solid fa-wallet fa-lg"></i>
                                <span>Wallet</span>
                            </Link>
                        </li> */}

                        <li className={isActivePath("/my-orders") ? "uk-active" : ""}>
                            <Link to="/my-orders" onClick={startRoutePreloader("/my-orders")}>
                                <i className="fa-solid fa-cart-arrow-down fa-lg" title="My orders"></i>
                                <span>My Orders</span>
                            </Link>
                        </li>

                        <li className={isActivePath("/creator") ? "uk-active" : ""}>
                            <Link to="/creator" onClick={startRoutePreloader("/creator")}>
                                <i className="fa-solid fa-user-tie fa-lg" title="Creator"></i>
                                <span>Creator</span>
                            </Link>
                        </li>

                        <li className={isActivePath("/refer-earn") ? "uk-active" : ""}>
                            <Link to="/refer-earn" onClick={startRoutePreloader("/refer-earn")}>
                                <i className="fa-solid fa-share-nodes fa-lg" title="Refer & Earn"></i>
                                <span>Refer & Earn</span>
                            </Link>
                        </li>

                        <li className="uk-nav-header">
                            <i className="uk-nav-devider" ></i>
                            <span>Support</span>
                        </li>

                        <li className={isActivePath("/faq") ? "uk-active" : ""}>
                            <Link to="/faq" onClick={startRoutePreloader("/faq")}>
                                <i className="fa-solid fa-circle-question fa-lg" title="FAQ"></i>
                                <span>FAQ's</span>
                            </Link>
                        </li>
                        <li>
                            <a href="https://discord.com/invite/s9A8EBFXpb" target="__blank" rel="noreferrer" onClick={()=>{
                                // ADD EVENT LOG.
                                // logEvent('RAISE_TICKET','CLICK','SIDEBAR');
                            }}>
                                <i className="fab fa-discord fa-lg" title="Raise Tickets"></i>
                                <span>Raise Ticket</span>
                            </a>
                        </li>
                        {/* <li className={isLoginActive ? "uk-active" : ""}>
                            <a href="#modal-login" onClick={openLoginModal}>
                                <i className="fa-solid fa-right-to-bracket fa-lg"></i>
                                <span>Login</span>
                            </a>
                        </li> */}
                        <li className={`uk-parent ${isPolicyOpen ? "uk-open" : ""} ${isAnyPolicyActive ? "" : ""}`}>
                            <a href="#" onClick={togglePolicyMenu}>
                                <i className="fa-solid fa-file-contract fa-lg" title="Policies"></i>
                                <span>Policies</span>
                                <i className={`fa-solid ${isPolicyOpen ? "fa-angle-down" : "fa-angle-right"}`}></i>
                            </a>
                            <ul className="uk-nav-sub" style={{ display: isPolicyOpen ? "block" : "none" }}>
                                <li className={isPolicyPath("/terms-and-conditions") ? "" : ""}>
                                    <Link to="/terms-and-conditions" onClick={startRoutePreloader("/terms-and-conditions")}><i className="fa-solid fa-file-signature fa-lg" title="Terms & conditions"></i><span>Terms & Conditions</span></Link>
                                </li>
                                <li className={isPolicyPath("/privacy-policy") ? "" : ""}>
                                    <Link to="/privacy-policy" onClick={startRoutePreloader("/privacy-policy")}><i className="fa-solid fa-user-shield fa-lg" title="Privacy Policy"></i><span>Privacy Policy</span></Link>
                                </li>
                                <li className={isPolicyPath("/cookie-policy") ? "" : ""}>
                                    <Link to="/cookie-policy" onClick={startRoutePreloader("/cookie-policy")}><i className="fa-solid fa-cookie-bite fa-lg" title="Cookie Policy"></i><span>Cookie Policy</span></Link>
                                </li>
                                <li className={isPolicyPath("/community-guidelines") ? "" : ""}>
                                    <Link to="/community-guidelines" onClick={startRoutePreloader("/community-guidelines")}><i className="fa-solid fa-users fa-lg" title="Community Guidelines"></i><span>Community Guidelines</span></Link>
                                </li>
                            </ul>
                        </li>
                        <li className={isActivePath("") ? "" : ""}>
                            <Link to="https://cges-club.gitbook.io/docs/" target="__blank" onClick={()=>{
                                //ADD EVENT LOG
                                //  logEvent('DEVELOPER_GUIDE','CLICK','SIDEBAR');
                            }}>
                                <i className="fa-solid fa-code fa-lg" title="Developer Guide"></i>
                                <span>Developer Guide</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </aside>
        </>
    );
}

